import React from "react";
import { Stack, Typography } from "@mui/material";
import {
  EXPORT_DATA_TYPES,
  EXPORT_INCLUSION_TYPES,
  ExportFieldConfiguration,
  EXPORT_FIELDS_INCLUSION_TYPES,
} from "./types";
import { getCommonExportRatioOptions } from "./utils";
import { ExportDataTypeInclusionSelector } from "./ExportDataTypeInclusionSelector";
import { FieldConfigurationSelector } from "./FieldConfigurationSelector";
import {
  contractExportFields,
  firmographicsExportFields,
} from "./exportConfigurationFields";

interface Props {
  inclusion: EXPORT_INCLUSION_TYPES;
  setInclusion?: (value: EXPORT_INCLUSION_TYPES) => void;
  universeEnabled?: boolean;
  contractFieldConfiguration?: ExportFieldConfiguration;
  setContractFieldConfiguration?: (cfg: ExportFieldConfiguration) => void;
  enforceMandatoryFields?: boolean;
}

export const ContractExportOptions: React.FC<Props> = ({
  inclusion,
  setInclusion,
  universeEnabled,
  contractFieldConfiguration,
  setContractFieldConfiguration,
  enforceMandatoryFields,
}) => {
  return (
    <Stack spacing={2} sx={{ width: "70%", paddingTop: "40px" }}>
      <Typography variant="h5" fontWeight={500} fontSize={16}>
        {EXPORT_DATA_TYPES.CONTRACTS}
      </Typography>
      <ExportDataTypeInclusionSelector
        dataType={EXPORT_DATA_TYPES.CONTRACTS}
        options={getCommonExportRatioOptions(EXPORT_DATA_TYPES.CONTRACTS)}
        inclusion={inclusion}
        setInclusion={setInclusion}
      />
      {universeEnabled && (
        <FieldConfigurationSelector
          fields={contractExportFields}
          firmographicsFields={firmographicsExportFields}
          value={
            contractFieldConfiguration ?? {
              inclusionType: EXPORT_FIELDS_INCLUSION_TYPES.ALL,
              fields: [],
            }
          }
          onChange={setContractFieldConfiguration ?? (() => {})}
          title="Contracts Fields"
          checkboxLabel="Export All Contracts Fields"
          // Matches OppGen: the note + force-injection of contract_uuid are only
          // active behind the universe_enforce_mandatory_fields_for_tracking flag.
          requiredField={
            enforceMandatoryFields
              ? {
                  values: ["contract_uuid"],
                  note: "Note: Contract UUID will always be included in your export for proper contract identification.",
                }
              : undefined
          }
          disabled={inclusion === EXPORT_INCLUSION_TYPES.NONE}
        />
      )}
    </Stack>
  );
};
